// store/tz/reducer.js
import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => ({
  image: '',
  name: '',
  description: '',
  description_elastic: '',
  quantity: 20,
  adress: '',
  patentObl: '',
  konstruktor: '',
  requests: '',
  imageReq:'',
  adressReq:'',
  patentOblRequests:'',

  // Состояния форм для сохранения введённых значений между переключениями вкладок
  forms: {
    name: { name: '', mktu: [], quantity: 20 },
    adress: { adress: '', mktu: [], quantity: 20 },
    description: { description: '', mktu: [], quantity: 20 },
    patentObl: { patentObl: '', mktu: [], quantity: 20 },
    image: { mktu: [], quantity: 20, fileName: '' },
    konstruktor: {
      text: '',
      mktu: [],
      quantity: 20,
      scope: 'tz',
      selectedFields: [],
      filters: [],
      isPhonetic: false,
    },
  },

  favorites: [],
  lastSearchQuery: '',
  lastImageForReport: null,
  /** Data URL картинки в форме «По содержанию» (для выгрузки base64 в сводке) */
  lastDescriptionSearchImageDataUrl: null,
  // Состояние формирования отчёта
  reportGenerating: false,
  reportError: null,
});

const initialState = getInitialState();

const tzSlice = createSlice({
  name: 'tz',
  initialState,
  reducers: {
    setFormValues: (state, action) => {
      const { formKey, values } = action.payload;
      if (!state.forms[formKey]) return;
      state.forms[formKey] = { ...state.forms[formKey], ...values };
    },
    addFavorite: (state, action) => {
      const id = String(action.payload.id);
      if (!state.favorites.some(fav => fav.id === id)) {
        state.favorites.push({ ...action.payload, id, isInteresting: false });
      }
    },
    removeFavorite: (state, action) => {
      const id = String(action.payload);
      state.favorites = state.favorites.filter(fav => fav.id !== id);
    },
    setFavoriteInteresting: (state, action) => {
      const { id, value } = action.payload;
      const favorite = state.favorites.find(fav => fav.id === id);
      if (favorite) {
        favorite.isInteresting = value;
      }
    },
    setLastSearchQuery: (state, action) => {
      state.lastSearchQuery = action.payload;
    },
    setLastImageForReport: (state, action) => {
      state.lastImageForReport = action.payload;
    },
    setLastDescriptionSearchImageDataUrl: (state, action) => {
      state.lastDescriptionSearchImageDataUrl = action.payload ?? null;
    },
    setReportGenerating: (state, action) => {
      state.reportGenerating = Boolean(action.payload);
    },
    setReportError: (state, action) => {
      state.reportError = action.payload || null;
    },
  },
});

export const {
  addFavorite,
  removeFavorite,
  setFavoriteInteresting,
  setLastSearchQuery,
  setLastImageForReport,
  setLastDescriptionSearchImageDataUrl,
  setReportGenerating,
  setReportError,
  setFormValues,
} = tzSlice.actions;

export default tzSlice.reducer;
